import React, { Component } from 'react';
import { Route, BrowserRouter as Router } from 'react-router-dom';
import './Resources/css/index.css';
import Login from './Components/Login/Login';
import ForgotPassword from './Components/Login/ForgotPassword';
import Dashboard from './Components/Dashboard/Dashboard.js';
import Userindex from './Components/Dashboard/index.js';
import Formindex from './Components/DynamicForm/index.js';
import Inventory from './Components/Inventory/Inventory.js';
import clientIndex from './Components/ClientManagement/clientIndex';
import Mapindex from './Components/AgentAuditorMapping/index'
import Samplingindex from './Components/Sampling/index';
import FileUpload from './Components/FileUpload/FileUpload'
import WorkListing from './Components/WorkListing/index'
import Surveyindex from './Components/CSAT/index'
import ComplianceIndex from './Components/Compliance/index'
import WebForm from './Components/WebForm/index'
import WebFormReport from './Components/WebForm/WebFormReport'
import Calibrationindex from './Components/Calibration/index'
import ReAssignindex from './Components/ReAssigining/index';
import SearchWorkItemindex from './Components/SearchWorkItem/index';
import UploadContactsindex from './Components/UploadContacts/index';
import RawDataindex from './Components/RawData/index';
import DynamicTableindex from './Components/DynamicTable/index';
// import ManualAssignindex from './Components/ManualAssign/index';


import ReportsCLIDIndex from './Components/Reports/index';
import ProductWiseIndex from './Components/Reports/productIndex';
import FirstAgentIndex from './Components/Reports/firstAgentIndex';
import TLRepeatIndex from './Components/Reports/tlRepeatIndex';
import SkillSetWiseIndex from './Components/Reports/skillSetWiseIndex';
import TNIIndex from './Components/Reports/TNIIndex';
import AgentNPSIndex from './Components/Reports/AgentNPSIndex';
import TLNPSIndex from './Components/Reports/TLNPSIndex';
import DateNPSReport from './Components/Reports/DateNPSIndex';
import ProductNPSReport from './Components/Reports/ProductNPSIndex';
import QAPerformaceIndex from './Components/Reports/QAPerformaceIndex';
import TaggingSpikeReportIndex from './Components/Reports/TaggingSpikeReportIndex';
import TaggingWiseCallVolumeIndex from './Components/Reports/TaggingWiseCallVolumeIndex';
import AgentWiseUniqueTaggingReport from './Components/Reports/AgentWiseUniqueTaggingReport';
import AgentWiseOverallTagging from './Components/Reports/AgentWiseOverallTagging';
import ParameterwiseAudit from './Components/Reports/ParameterwiseAudit';
import AHTWiseScore from './Components/Reports/AHTWiseScore';
import TenureWiseScore from './Components/Reports/TenureWiseScore';
import webFormReport from './Components/Reports/webFormReport';
import Productwisescore from './Components/Reports/Productwisescore';
import TlwiseScore from './Components/Reports/Tlwisescore';
import SkillSetwiseScore from './Components/Reports/SkillSetwiseScore';
import Agentwisescore from './Components/Reports/Agentwisescore';
import taggingwiseAHT from './Components/Reports/taggingwiseAHT';
import taggingwiseRepeat from './Components/Reports/taggingwiseRepeat';
import NPSdetailed from './Components/Reports/NPSdetailed';
import NPSSummary from './Components/Reports/NPSSummary';
import AgentWiseRepeatReport from './Components/Reports/AgentWiseRepeatReport';
import QAWiseAlignment from './Components/Reports/QAWiseAlignment';
import AgentBanding from './Components/Reports/AgentBanding';
import MontlyAuditReport from './Components/Reports/MontlyAuditReport';
import QAPAudits from './Components/Reports/Qapaudits';
import VarinaceDetails from './Components/Reports/VarianceReportDetail';
import Variance from  './Components/Reports/varianceReport';
import ClientView from './Components/Reports/clientView';
import ManagementSummary from  './Components/Reports/managementSummary';
import ManagementView from './Components/Reports/managementView';
class App extends Component {  
  render() {
    return (
      <Router>      
        <Route exact path ="/" component={Login} />
        <Route path ="/Dashboard" component={Dashboard} />
        <Route exact path ="/ForgotPassword" component={ForgotPassword} />
        <Route path ="/Dashboard/Users" component={Userindex} />       
        <Route path ="/Dashboard/FormBuilder" component={Formindex} />
        <Route path ="/Dashboard/Inventory" component={Inventory} />
        <Route path ="/Dashboard/ClientManagement" component={clientIndex} />
        <Route path ="/Dashboard/AgentMapping" component={Mapindex} />
        <Route path ="/Dashboard/Sampling" component={Samplingindex} />
        <Route path ="/Dashboard/FileUpload" component={FileUpload} />
        <Route path ="/Dashboard/Inbox" component={WorkListing} />
        <Route path ="/Dashboard/CSAT" component={Surveyindex} />
        <Route path ="/Dashboard/Compliance" component={ComplianceIndex} />
        <Route path ="/Dashboard/WebForm" component={WebForm} />        
        <Route path ="/Dashboard/WebFormReportSubmission" component={WebFormReport} />
        <Route path ="/Dashboard/Calibration" component={Calibrationindex} />
        <Route path ="/Dashboard/Re-Assign" component={ReAssignindex} />      
        <Route path ="/Dashboard/UploadContacts" component={UploadContactsindex} />  
        <Route path ="/Dashboard/DataDump" component={RawDataindex} />  
        <Route path ="/Dashboard/SearchWI" component={SearchWorkItemindex} /> 
        <Route path ="/Dashboard/CLIDRepeatReport" component={ReportsCLIDIndex} />
        <Route path ="/Dashboard/ReportProductWiseRepeatReport" component={ProductWiseIndex} />
        <Route path ="/Dashboard/FirstAgentRepeatReport" component={FirstAgentIndex} />
        <Route path ="/Dashboard/TLWiseRepeatReport" component={TLRepeatIndex} />
        <Route path ="/Dashboard/SkillSetWiseRepeatReport" component={SkillSetWiseIndex} />
        <Route path ="/Dashboard/TNIReport" component={TNIIndex} />
        <Route path ="/Dashboard/AgentNPSReport" component={AgentNPSIndex} />
        <Route path ="/Dashboard/TLNPSReport" component={TLNPSIndex} />
        <Route path ="/Dashboard/DateNPSReport" component={DateNPSReport} />
        <Route path ="/Dashboard/ProductNPSReport" component={ProductNPSReport} />
        <Route path ="/Dashboard/QAPerformanceMonth" component={QAPerformaceIndex} />
        <Route path ="/Dashboard/TaggingSpikeReport" component={TaggingSpikeReportIndex} />
        <Route path ="/Dashboard/TaggingWiseCallVolume" component={TaggingWiseCallVolumeIndex} />
        <Route path ="/Dashboard/AgentWiseUniqueTaggingReport" component={AgentWiseUniqueTaggingReport} />
        <Route path ="/Dashboard/AgentWiseOverallTagging" component={AgentWiseOverallTagging} />        
        <Route path ="/Dashboard/ParameterwiseAudit" component={ParameterwiseAudit} />
        <Route path ="/Dashboard/AHTWiseScore" component={AHTWiseScore} />
        <Route path ="/Dashboard/TenureWiseScore" component={TenureWiseScore} />
        <Route path ="/Dashboard/webFormReport" component={webFormReport} />
        <Route path ="/Dashboard/Productwisescore" component={Productwisescore} />
        <Route path ="/Dashboard/TlwiseScore" component={TlwiseScore} />
        <Route path ="/Dashboard/SkillSetwiseScore" component={SkillSetwiseScore} />
        <Route path ="/Dashboard/Agentwisescore" component={Agentwisescore} />
        <Route path ="/Dashboard/taggingwiseAHT" component={taggingwiseAHT} />
        <Route path ="/Dashboard/taggingwiseRepeat" component={taggingwiseRepeat} />
        <Route path ="/Dashboard/NPSdetailed" component={NPSdetailed} />
        <Route path ="/Dashboard/NPSSummary" component={NPSSummary} />        
        <Route path ="/Dashboard/AgentwiseRepeatReport" component={AgentWiseRepeatReport} /> 
        <Route path ="/Dashboard/QAWiseAlignment" component={QAWiseAlignment} /> 
        <Route path ="/Dashboard/AgentBanding" component={AgentBanding} /> 
        <Route path ="/Dashboard/MontlyAuditReport" component={MontlyAuditReport} /> 
        <Route path ="/Dashboard/VarinaceDetails" component={VarinaceDetails} /> 
        <Route path ="/Dashboard/Variance" component={Variance} /> 
        <Route path ="/Dashboard/QAPaudits" component={QAPAudits} /> 
        <Route path ="/Dashboard/ClientView" component={ClientView} /> 
        <Route path ="/Dashboard/ManagementSummary" component={ManagementSummary} /> 
        <Route path ="/Dashboard/ManagementView" component={ManagementView} /> 
        <Route path ="/Dashboard/DynamicCreation" component={DynamicTableindex} />         
        {/* <Route path ="/Dashboard/ManualAssign" component={ManualAssignindex} />          */}
        </Router>       
    )
  }
}

export default App;
